import { useContext } from 'react'
import { UserData } from 'react-oidc'
import { IAuthenticatorContext } from 'react-oidc/lib/makeAuth'

export default function useUserData(): IAuthenticatorContext {
  const context = useContext(UserData)

  return context
}
